import { styled } from '@styledComponents';
import { Columns } from '@components/Columns';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { Avatar } from '@components/Avatar';

export const DataColumns = styled(Columns)<{ reverse?: boolean }>`
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    display: flex;
    flex-direction: ${({ reverse }) => (reverse ? 'column-reverse' : 'column')};
    min-height: 550px;
  }
`;

export const LeftColumn = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    display: block;
    justify-content: center;
    align-items: center;
    margin-bottom: ${themeSpace(4)};
    margin-top: ${themeSpace(4)};
    div {
      align-items: center;
    }
  }
`;

export const RightColumn = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    display: block;
    justify-content: center;
    align-items: center;
    div {
      align-items: center;
    }
  }
`;

export const RightColumnAvatar = styled(RightColumn)`
  margin-top: ${themeSpace(12)};
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(10)};
  }
  ${themeMediaQuery('sm')} {
    margin-left: ${themeSpace(0)};
  }
`;

export const ManageTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 330px;
    ${themeMediaQuery('xl')} {
      max-width: 350px;
    }
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
  .text-pairing-body {
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
`;

export const PriorityTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 250px;
    ${themeMediaQuery('xl')} {
      max-width: 330px;
    }
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
  .text-pairing-body {
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
`;

export const FilterTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 230px;
    ${themeMediaQuery('xl')} {
      max-width: 320px;
    }
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
  .text-pairing-body {
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
`;

export const BlurbsAsset1Wrap = styled(Box)`
  width: 85%;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;

export const BlurbsAsset3Wrap = styled(Box)`
  width: 103%;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;

export const ListWrapper = styled(Box)`
  display: flex;
  justify-content: left;
  padding-left: ${themeSpace(4)};
  height: 74px;
  margin-bottom: ${themeSpace(7)};
  ${themeMediaQuery('below_sm')} {
    margin-bottom: ${themeSpace(5)};
    padding-left: ${themeSpace(9)};
  }
`;

export const ListCloudImage = styled(CloudImage)`
  ${themeMediaQuery('below_sm')} {
    height: 65px;
    width: fit-content;
    margin-top: -17px;
  }
`;

export const ListAvatarsDiv = styled.div`
  display: flex;
  justify-content: center;
  padding-left: ${themeSpace(12)};
  margin-top: -17px;
  ${themeMediaQuery('below_sm')} {
    padding-left: ${themeSpace(-5)};
  }
`;

export const ListAvatar = styled(Avatar).attrs({
  sizeVariant: ['110px', '125px', '130px'],
  strokeWidth: '2px',
  strokeColor: 'white',
  className: 'list-avatar',
})`
  display: flex;
  justify-content: center;
  transform: scale(0.5);
  opacity: 1;
  margin-left: -8.14rem;
  ${themeMediaQuery('below_sm')} {
    margin-left: -6.9rem;
  }
`;

export const ListAvatarText = styled(ListAvatar)`
  transform: scale(0.6);
  margin-top: -5px;
  img {
    border-width: 0px;
    background: white;
    border-radius: 50%;
    box-shadow: rgb(44 41 37 / 10%) 0px 9.1328px 24.6586px -4.5664px, rgb(0 0 0 / 10%) 0px 6.39296px 14.6125px -7.30624px;
  }
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(-3)};
  }
  ${themeMediaQuery('sm')} {
    transform: scale(0.65);
  }
  ${themeMediaQuery('md')} {
    transform: scale(0.6);
  }
`;
